<template>
  <div class="my-3 mr-md-0 mr-3">
    <LocationNew
      v-if="false &&locationFormat === 0"
      :locationOriginal="locationOriginal"
      v-bind:value="value"
      v-on:input="updateInput"
      ref="locationNew"
    ></LocationNew>
    <LocationExisting
      v-else-if="true || locationFormat === 1"
      :locationOriginal="locationOriginal"
      :projectId="projectId"
      :datasheetId="datasheetId"
      :projectUrlField="projectUrlField"
      :isManager="isManager"
      :key="locationOriginal ? locationOriginal['@id'] : 'new'"
      v-bind:value="value"
      v-on:input="updateInput"
      ref="locationExisting"
    ></LocationExisting>
    <LocationBoth
      v-else-if="false && locationFormat === 2"
      :locationOriginal="locationOriginal"
      :projectId="projectId"
      :datasheetId="datasheetId"
      v-bind:value="value"
      v-on:input="updateInput"
      ref="locationBoth"
    ></LocationBoth>
    <div v-else>This Datasheet does not require a location</div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import LocationNew from "./locationNew.vue";
import LocationExisting from "./locationExisting.vue";
import LocationBoth from "./locationBoth.vue";

export default {
  name: "ObservationLocationEditor",
  components: {
    LocationNew,
    LocationExisting,
    LocationBoth,
  },
  data() {
    return {
      home: { lng: null, lat: null },
    };
  },
  props: {
    value: {
      // currently seclected location, can be null
      type: Object,
      default: null,
    },
    locationOriginal: {
      type: Object,
      default: null,
    },
    locationFormat: {
      type: Number,
      default: 3,
    },
    datasheetId: {
      type: String,
      default: null,
    },
    projectId: {
      type: String,
      required: true,
    },
    projectUrlField: {
      type: String,
      required: true,
    },
    isManager: {
      type: Boolean,
      required: true,
    },
  },
  mounted(){
  },
  computed: {
  },
  methods: {
    updateInput(location) {
      this.$emit("input", location);
    },
    validate() {
      if (this.$refs.locationNew && this.$refs.locationNew.validateLocation) {
        return this.$refs.locationNew.validateLocation();
      } else if (
        this.$refs.locationExisting &&
        this.$refs.locationExisting.validateLocation
      ) {
        return this.$refs.locationExisting.validateLocation();
      } else if (
        this.$refs.locationBoth &&
        this.$refs.locationBoth.validateLocation
      ) {
        return this.$refs.locationBoth.validateLocation();
      } else {
        return Promise.resolve(true);
      }
    },
  },
};
</script>
<style lang="css" scoped></style>
